import { call, put } from "redux-saga/effects";
import { keysToLowerCase } from "../../../Utils/formant";
import * as API from "../../Connections/API/SuperAdmin";
import * as dispatchAction from "../Action/Actions";

export function* getAllOrgSaga(action) {
  try {
    const response = yield call(API.getOrgApi, action.data);
    yield put(
      dispatchAction.getOrganizationSuccessAction(response, action.getAll)
    );
  } catch (error) {
    yield put(dispatchAction.getOrganizationFailAction(error));
  }
}

export function* getTenantsSaga(action) {
  try {
    const response = yield call(API.getTenantsApi, action.data);
    yield put(dispatchAction.getAllTenantsSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getAllTenantsFailAction(error));
  }
}

export function* addOrgSaga(action) {
  try {
    const response = yield call(API.addOrgApi, action.data);
    yield put(dispatchAction.addOrgSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.addOrgFailAction(error));
  }
}

export function* editOrgSaga(action) {
  try {
    const response = yield call(API.editOrgApi, action.data);
    yield put(dispatchAction.editOrgSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.editOrgFailAction(error));
  }
}

export function* addTenantSaga(action) {
  try {
    const response = yield call(API.addTenantApi, action.data);
    yield put(dispatchAction.addTenantSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.addTenantFailAction(error));
  }
}

export function* SetCustomSmsSaga(action) {
  try {
    const response = yield call(API.SetCustomSmsApi, action.data);
    yield put(dispatchAction.setCustomSmsSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.setCustomSmsFailAction(error));
  }
}

export function* CustomSmsListSaga(action) {
  try {
    const response = yield call(API.getCustomSmsApi, action.data);
    yield put(dispatchAction.getCustomSmsSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getCustomSmsFailAction(error));
  }
}

export function* editTenantSaga(action) {
  try {
    const response = yield call(API.editTenantApi, action.data);
    yield put(dispatchAction.editTenantSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.editTenantFailAction(error));
  }
}

export function* restorePlanSaga(action) {
  try {
    const response = yield call(API.restorePlanApi, action.data);
    yield put(dispatchAction.restorePlanSuccessAction(response.data));
  } catch (error) {
    yield put(dispatchAction.restorePlanFailAction(error));
  }
}

export function* getOrgByIdSaga(action) {
  try {
    const response = yield call(API.getOrgByIdApi, action.data);
    yield put(dispatchAction.getOrgByIdSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getOrgByIdFailAction(error));
  }
}

export function* setPlanStatusSaga(action) {
  try {
    const response = yield call(API.setPlanStatusApi, action.data);
    yield put(dispatchAction.setPlanStatusSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.setPlanStatusFailAction(error));
  }
}

export function* changeOrgActivationSaga(action) {
  try {
    const response = yield call(API.changeOrgActivationApi, action.data);
    yield put(dispatchAction.changeOrgActivationSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.changeOrgActivationFailAction(error));
  }
}

export function* changeTenantActivationSaga(action) {
  try {
    const response = yield call(API.changeTenantActivationApi, action.data);
    yield put(dispatchAction.changeTenantActivationSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.changeTenantActivationFailAction(error));
  }
}

export function* deleteTenantSaga(action) {
  try {
    const response = yield call(API.deleteTenantApi, action.data);
    yield put(dispatchAction.deleteTenantSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.deleteTenantFailAction(error));
  }
}

export function* getTenantByIdSaga(action) {
  try {
    const response = yield call(API.getTenantByIdApi, action.data);
    yield put(dispatchAction.getTenantByIdSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getTenantByIdFailAction(error));
  }
}

export function* getOrganizationUserSaga(action) {
  try {
    const response = yield call(API.getOrganizationUserApi, action.data);
    yield put(dispatchAction.getOrganizationUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getOrganizationUserFailAction(error));
  }
}

export function* getTenantUserSaga(action) {
  try {
    const response = yield call(API.getTenantUserApi, action.data);
    yield put(dispatchAction.getTenantUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getTenantUserFailAction(error));
  }
}

export function* updateOrgUserSaga(action) {
  try {
    const response = yield call(API.updateOrgUserApi, action.data);
    yield put(dispatchAction.updateOrgUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.updateOrgUserFailAction(error));
  }
}

export function* updateTenantUserSaga(action) {
  try {
    const response = yield call(API.updateTenantUserApi, action.data);
    yield put(dispatchAction.updateTenantUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.updateTenantUserFailAction(error));
  }
}

export function* changeOrgPassowrdSaga(action) {
  try {
    const response = yield call(API.changeOrganizationPasswordApi, action.data);
    yield put(dispatchAction.changeOrganizationPasswordSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.changeOrganizationPasswordFailAction(error));
  }
}

export function* changeTenantPassowrdSaga(action) {
  try {
    const response = yield call(API.changeTenantPasswordApi, action.data);
    yield put(dispatchAction.changeTenantPasswordSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.changeTenantPasswordFailAction(error));
  }
}

export function* getUserTokenSaga(action) {
  try {
    const response = yield call(API.getOrgsListIdApi, action.data);
    yield put(dispatchAction.getUserTokenSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getUserTokenFailAction(error));
  }
}

export function* getOrgsListIdSaga(action) {
  try {
    const response = yield call(API.getOrgsListIdApi, action.data);
    yield put(dispatchAction.getOrgsListIdSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getOrgsListIdFailAction(error));
  }
}

export function* getUserTokenByTenantIdSaga(action) {
  try {
    const response = yield call(API.getUserTokenByTenantIdApi, action.data);
    yield put(dispatchAction.getUserTokenSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getUserTokenFailAction(error));
  }
}

export function* getOrganizationUsageSaga(action) {
  try {
    const response = yield call(API.getOrganizationUsageApi, action.data);
    yield put(
      dispatchAction.getOrganizationUsageSuccessAction(
        response,
        action.data.interval
      )
    );
  } catch (error) {
    yield put(dispatchAction.getOrganizationUsageFailAction(error));
  }
}

export function* getOrganizationsUsageSaga(action) {
  try {
    const response = yield call(API.getOrganizationsUsageApi, action.data);
    yield put(
      dispatchAction.getOrganizationsUsageSuccessAction(
        response,
        action.data.interval
      )
    );
  } catch (error) {
    yield put(dispatchAction.getOrganizationsUsageFailAction(error));
  }
}

export function* downloadOptimizeFileSaga(action) {
  try {
    const response = yield call(API.DownloadResultOptimzeFileApi, action.plan);
    yield put(
      dispatchAction.downloadOptimizeFileSuccessAction(
        keysToLowerCase(response.data)
      )
    );
  } catch (error) {
    yield put(dispatchAction.downloadOptimizeFileFailAction(error));
  }
}

export function* downloadUsageSaga(action) {
  try {
    const response = yield call(API.downloadUsageApi, action.data);
    yield put(dispatchAction.downloadUsageSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.downloadUsageFailAction(error));
  }
}

export function* downloadExcelFileSaga(action) {
  try {
    const response = yield call(API.DownloadExcelFileApi, action.plan);
    yield put(
      dispatchAction.downloadExcelFileSuccessAction(
        keysToLowerCase(response.data)
      )
    );
  } catch (error) {
    yield put(dispatchAction.downloadExcelFileFailAction(error));
  }
}

export function* getOrgPOCSaga(action) {
  try {
    const response = yield call(API.getOrgPOCApi, action.data);
    yield put(
      dispatchAction.getOrgPOCSuccessAction(response, action.data.interval)
    );
  } catch (error) {
    yield put(dispatchAction.getOrgPOCFailAction(error));
  }
}

export function* updateOrgPOCSaga(action) {
  try {
    const response = yield call(API.updateOrgPOCApi, action.data);
    yield put(dispatchAction.updateOrgPOCSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.updateOrgPOCFailAction(error));
  }
}

export function* addOrgPOCSaga(action) {
  try {
    const response = yield call(API.addOrgPOCApi, action.data);
    yield put(dispatchAction.addOrgPOCTypeSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.addOrgPOCTypeFailAction(error));
  }
}

export function* removeOrgPOCSaga(action) {
  try {
    const response = yield call(API.removeOrgPOCApi, action.data);
    yield put(dispatchAction.removeOrgPOCTypeSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.removeOrgPOCTypeFailAction(error));
  }
}

export function* OrgAdminsSaga(action) {
  try {
    const response = yield call(API.OrgAdminsApi, action.data);
    yield put(dispatchAction.getOrganizationAdminSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getOrganizationAdminFailAction(error));
  }
}

export function* addOrgAdminSaga(action) {
  try {
    const response = yield call(API.addOrgAdminApi, action.data);
    yield put(dispatchAction.addOrgAdminSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.addOrgAdminFailAction(error));
  }
}

export function* getAllPlansSaga(action) {
  try {
    const response = yield call(API.getAllPlansApi, action.data);
    yield put(dispatchAction.getAllPlansSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getAllPlansFailAction(error));
  }
}

export function* setWebhookConfigSaga(action) {
  try {
    const response = yield call(API.setWebhookConfigApi, action.data);
    yield put(dispatchAction.setWebhookConfigSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.setWebhookConfigFailAction(error));
  }
}

export function* getWebhookConfigSaga(action) {
  try {
    const response = yield call(API.getWebhookConfigApi, action.data);
    yield put(dispatchAction.getWebHookConfigSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getWebHookConfigFailAction(error));
  }
}

export function* setVerificationCodeConfigSaga(action) {
  try {
    const response = yield call(API.setVerificationCodeConfigApi, action.data);
    yield put(dispatchAction.setVerificationCodeConfigSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.setVerificationCodeConfigFailAction(error));
  }
}

export function* getVerificationCodeConfigSaga(action) {
  try {
    const response = yield call(API.getVerificationCodeConfigApi, action.data);
    yield put(dispatchAction.getVerificationCodeConfigSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getVerificationCodeConfigFailAction(error));
  }
}

export function* changeUserActivationSaga(action) {
  try {
    const response = yield call(API.changeUserActivationApi, action.data);
    yield put(dispatchAction.changeUserActivationSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.changeUserActivationFailAction(error));
  }
}

export function* createTenantUserSaga(action) {
  try {
    const response = yield call(API.createTenantUserApi, action.data);
    yield put(dispatchAction.createTenantUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.createTenantUserFailAction(error));
  }
}

export function* createOrgUserSaga(action) {
  try {
    const response = yield call(API.createOrgUserApi, action.data);
    yield put(dispatchAction.createOrgUserSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.createOrgUserFailAction(error));
  }
}

export function* getRoleFlagsSaga(action) {
  try {
    const response = yield call(API.getRoleFlagApi, action.data);
    yield put(dispatchAction.getRoleFlagsSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getRoleFlagsFailAction(error));
  }
}

export function* getOrgRoleFlagsSaga(action) {
  try {
    const response = yield call(API.getOrgRoleFlagApi, action.data);
    yield put(dispatchAction.getRoleFlagsSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getRoleFlagsFailAction(error));
  }
}

export function* getAllTenantUsersSaga(action) {
  try {
    const response = yield call(API.getAllTenantUsersApi, action.data);
    yield put(dispatchAction.getAllTenantUsersSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getAllTenantUsersFailAction(error));
  }
}

export function* getAllOrgUsersSaga(action) {
  try {
    const response = yield call(API.getAllOrgUsersApi, action.data);
    yield put(dispatchAction.getAllOrgUsersSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getAllOrgUsersFailAction(error));
  }
}

export function* getUserOfTenantSaga(action) {
  try {
    const response = yield call(API.getUserOfTenantApi, action.data);
    yield put(dispatchAction.getUserByIdSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getUserByIdFailAction(error));
  }
}

export function* getMissionReasonSaga(action) {
  try {
    const response = yield call(API.getMissionReasonApi, action.data);
    yield put(dispatchAction.getMissionReasonSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getMissionReasonFailAction(error));
  }
}

export function* addMissionReasonSaga(action) {
  try {
    const response = yield call(API.addMissionReasonApi, action.data);
    yield put(dispatchAction.addMissionReasonSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.addMissionReasonFailAction(error));
  }
}

export function* deleteMissionReasonSaga(action) {
  try {
    const response = yield call(API.deleteMissionReasonApi, action.data);
    yield put(dispatchAction.deleteMissionReasonSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.deleteMissionReasonFailAction(error));
  }
}

export function* updateMissionReasonSaga(action) {
  try {
    const response = yield call(API.updateMissionReasonApi, action.data);
    yield put(dispatchAction.updateMissionReasonSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.updateMissionReasonFailAction(error));
  }
}

export function* changeUserPasswordSaga(action) {
  try {
    const response = yield call(API.changeUserPasswordApi, action.data);
    yield put(dispatchAction.changeUserPasswordSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.changeUserPasswordFailAction(error));
  }
}

export function* getRoleOrgsSaga() {
  try {
    const response = yield call(API.getRoleOrgsApi);
    yield put(dispatchAction.getRoleOrgsSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getRoleOrgsFailAction(error));
  }
}

export function* addRoleSaga(action) {
  try {
    const response = yield call(API.addRoleApi, action.data);
    yield put(dispatchAction.addRoleSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.addRoleFailAction(error));
  }
}
export function* deleteRoleSaga(action) {
  try {
    const response = yield call(API.deleteRoleApi, action.item);
    yield put(dispatchAction.deleteRoleSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.deleteRoleFailAction(error));
  }
}

export function* editRoleSaga(action) {
  try {
    const response = yield call(API.editRoleApi, action.data);
    yield put(dispatchAction.editRoleSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.editRoleFailAction(error));
  }
}

export function* getAllRolesSaga() {
  try {
    const response = yield call(API.getAllRolesApi);
    yield put(dispatchAction.getAllRolesSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getAllRolesFailAction(error));
  }
}

export function* getRoleByIdSaga(action) {
  try {
    const response = yield call(API.getRoleByIdApi, action.id);
    yield put(dispatchAction.getRoleByIdSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getRoleByIdFailAction(error));
  }
}

export function* getMenuSaga(action) {
  try {
    const response = yield call(API.getMenuApi, action.data);
    yield put(dispatchAction.getMenuSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getMenuFailAction(error));
  }
}

export function* getActionSaga(action) {
  try {
    const response = yield call(API.getActionApi, action.data);
    yield put(dispatchAction.getActionSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getActionFailAction(error));
  }
}

export function* getLogsSaga(action) {
  try {
    const response = yield call(API.getLogsApi, action.data);
    yield put(dispatchAction.getLogHistorySuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getLogHistoryFailAction(error));
  }
}

export function* getAllContractsSaga(action) {
  try {
    const response = yield call(API.getAllContractsApi, action.data);
    yield put(dispatchAction.getAllContractsSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getAllContractsFailAction(error));
  }
}

export function* addContractSaga(action) {
  try {
    const response = yield call(API.addContractApi, action.data);
    yield put(dispatchAction.addContractSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.addContractFailAction(error));
  }
}

export function* deleteContractSaga(action) {
  try {
    const response = yield call(API.deleteContractApi, action.item);
    yield put(dispatchAction.deleteContractSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.deleteContractFailAction(error));
  }
}

export function* editContractSaga(action) {
  try {
    const response = yield call(API.editContractApi, action.data);
    yield put(dispatchAction.editContractSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.editContractFailAction(error));
  }
}

export function* getAccountUsageSaga(action) {
  try {
    const response = yield call(API.getAccountUsageApi, action.data);
    yield put(dispatchAction.getAccountUsageSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.getAccountUsageFailAction(error));
  }
}

export function* clonePlanSaga(action) {
  try {
    const response = yield call(API.clonePlanApi, action.data);
    yield put(dispatchAction.clonePlanSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.clonePlanFailAction(error));
  }
}

export function* createAppVersionSaga(action) {
  try {
    const response = yield call(API.createAppVersionApi, action.data);
    yield put(dispatchAction.createAppVersionSuccessAction(response));
  } catch (error) {
    yield put(dispatchAction.createAppVersionFailAction(error));
  }
}
